import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from '@components/index.components';
import { TranslateModule } from '@ngx-translate/core';
import { SlotInformationComponent } from '@components/slot/slot-information/slot-information.component';
import { AlertComponent } from './alert/alert.component';
import { ConfirmationModalComponent } from '@components/modals/confirmation-modal/confirmation-modal.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule
  ],
  declarations: [
    LoadingComponent,
    SlotInformationComponent,
    AlertComponent,
    ConfirmationModalComponent
  ],
  exports: [
    LoadingComponent,
    SlotInformationComponent,
    AlertComponent,
    ConfirmationModalComponent
  ],
  entryComponents: [
    ConfirmationModalComponent
  ]
})
export class ComponentsModule { }
